import { ParseRequestData } from './../../stores/parse-requests.store';
import { Component, computed, input } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { ParseRequestStateIcon } from '../parse-request-state-icon/parse-request-state-icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../../environments/environment';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';

@Component({
  selector: 'app-parse-request-create-nav',
  imports: [
    Button,
    NgIcon,
    ParseRequestStateIcon,
    RouterLink,
    RouterLinkActive,
    NgClass,
    TranslocoPipe,
    FeatureEnabledDirective,
  ],
  templateUrl: './parse-request-create-nav.html',
})
export class ParseRequestCreateNav {
  parseRequest = input.required<ParseRequestData | null>();

  protected sidebarNavInfoButtonLink = computed(
    () => environment.articles.parseRequest.sidebarNavInfoButton,
  );
}
